import {
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Modal,
  Row,
  Select,
} from "antd";
import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import data from "../../data/hire-space-spaces.json";
import { SPACE_ID_MEETING_ROOM } from "../../constants/SpacesConstants";
import locale from "antd/es/date-picker/locale/nl_NL";
import { getDisableDatesForMeetingRoom } from "../../functions/Datepicker";
import dayjs from "dayjs";
import { HIRE_REQUEST_STATUS_OPEN } from "../../constants/HireRequestConstants";
import { useFirestore } from "react-redux-firebase";
import { FIRESTORE_HIRE_REQUESTS_TABLE } from "../../constants/FirebaseConstants";

const { Option } = Select;

export default function HireSpaceAdminModal({ open, onCancel }) {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const firestore = useFirestore();
  const SPACES_DATA = data[lang];
  const [form] = Form.useForm();
  const [chosenSpace, setChosenSpace] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = () => {
    form.validateFields().then((values) => {
      setIsLoading(true);
      if (!!values.reservationDate)
        values.reservationDate = dayjs(values.reservationDate).format(
          "DD-MM-YYYY",
        );
      else delete values.reservationDate;
      if (!values.timePeriod) delete values.timePeriod;
      if (!values.occupation) delete values.occupation;
      values.createdAt = dayjs().unix();
      values.status = HIRE_REQUEST_STATUS_OPEN;
      values.phone = values.phone || null;
      values.createdByAdmin = true;

      try {
        firestore
          .collection(FIRESTORE_HIRE_REQUESTS_TABLE)
          .add(values)
          .then(() => {
            message.success(t("notifications.request_created"));
          });
      } catch (error) {
        console.log(error);
        message.error(t("errors.generic"));
      } finally {
        setIsLoading(false);
        closeModal();
      }
    });
  };

  const closeModal = () => {
    form.resetFields();
    setChosenSpace(null);
    onCancel();
  };

  return (
    <Modal
      open={open}
      onOk={handleSubmit}
      onCancel={closeModal}
      title={t("create_new_request")}
      okText={t("save")}
      cancelText={t("close")}
      okButtonProps={{ htmlType: "submit", loading: isLoading }}
      width={750}
    >
      <Form form={form} layout={"vertical"}>
        <Row gutter={[16, 0]}>
          <Col xs={24} md={12}>
            <Form.Item
              name="firstName"
              label={t("first_name")}
              rules={[
                {
                  required: true,
                  message: t("form.enter_first_name"),
                },
              ]}
            >
              <Input placeholder={t("first_name")} />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              name="lastName"
              label={t("last_name")}
              rules={[
                {
                  required: true,
                  message: t("form.enter_last_name"),
                },
              ]}
            >
              <Input placeholder={t("last_name")} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={24} md={12}>
            <Form.Item
              name="email"
              label={t("email")}
              rules={[
                {
                  required: true,
                  message: t("form.enter_email"),
                },
                {
                  type: "email",
                  message: t("form.enter_valid_email"),
                },
              ]}
            >
              <Input placeholder={t("email")} />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item name="phone" label={t("phone_number")}>
              <Input placeholder={t("phone_number")} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={24} md={12}>
            <Form.Item
              name={"chosenSpace"}
              label={t("space_type")}
              rules={[
                {
                  required: true,
                  message: t("form.select_space_type"),
                },
              ]}
            >
              <Select
                placeholder={t("space_type")}
                onChange={(value) => setChosenSpace(value)}
              >
                {SPACES_DATA.map((item, index) => (
                  <Option key={index} value={item.id}>
                    {item.title}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        {!!chosenSpace && (
          <>
            {chosenSpace === SPACE_ID_MEETING_ROOM ? (
              <Row gutter={16}>
                <Col xs={24} md={12}>
                  <Form.Item name="reservationDate" label={t("date")}>
                    <DatePicker
                      className={"w-100"}
                      locale={locale}
                      format={"DD-MM-YYYY"}
                      placeholder={t("choose_date")}
                      showToday={false}
                      inputReadOnly={true}
                      disabledDate={(current) => {
                        return getDisableDatesForMeetingRoom(current);
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item name="timePeriod" label={t("part_of_day")}>
                    <Select placeholder={t("placeholders.choose_time_period")}>
                      <Select.Option value="morning">
                        {t("morning")}
                      </Select.Option>
                      <Select.Option value="afternoon">
                        {t("afternoon")}
                      </Select.Option>
                      <Select.Option value="whole_day">
                        {t("whole_day")}
                      </Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            ) : (
              <Row>
                <Col xs={24}>
                  <Form.Item name="occupation" label={t("occupation")}>
                    <Input.TextArea />
                  </Form.Item>
                </Col>
              </Row>
            )}
          </>
        )}
      </Form>
    </Modal>
  );
}
